/**
 * @GestionalePD User Dashboard UI
 */
import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid, Container, Card, CardHeader, CardContent, Typography } from '@mui/material';
import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
// -----------------------------------------------------------------------
import { DefaultContainedButton } from '../../utils/Buttons';
import { AppCalendar, AppProfile } from '../../sections/app';
/**
 * @returns User Dashboard UI
 */
export default function DashboardAppPage() {
  const [currentProfile, setCurrentProfile] = useState('');

  // get user data
  useEffect(() => {
    let data;

    if (localStorage.getItem('userData') !== 'undefined') data = JSON.parse(localStorage.getItem('userData'));

    if (data) {
      const _currentProfile = data.roles.filter((role) => role.last_used);
      setCurrentProfile(_currentProfile);
    }
  }, []);

  if (currentProfile && currentProfile[0].prof_type_name !== 'USER') return <Navigate to={{ pathname: '/' }} />;

  return (
    <div>
      <Helmet>
        <title>Dashboard Utente</title>
      </Helmet>

      <Container maxWidth="xl">
        <Grid container spacing={3}>
          {/* User profile card */}
          <Grid item xs={12} md={7}>
            <AppProfile />
          </Grid>

          {/* User Calendar Event card UI */}
          <Grid item xs={12} md={5}>
            <AppCalendar title="Calendario Eventi" isAdmin={false} />
          </Grid>

          <Grid item xs={12} md={4}>
            <Card
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
                maxWidth: 400,
                borderRadius: 2,
                backgroundColor: 'background.paper',
              }}
            >
              <CardHeader
                title={
                  <Typography variant="h6" fontWeight="bold">
                    Partecipa alla campagna di ascolto
                  </Typography>
                }
                sx={{ textAlign: 'center', justifyContent: 'center' }}
              />
              <CardContent
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1.5,
                  textAlign: 'center',
                  paddingTop: 2,
                }}
              >
                <img
                  src="/assets/images/img/dashboard_italy.png"
                  alt="Logo"
                  style={{ width: 120, height: 120, borderRadius: 8, margin: '0 auto' }}
                />
                <Typography variant="body1">
                  Collegati a questo link per compilare i questionari dell’indagine sociale con altre volontarie e
                  volontari.
                </Typography>
                <Typography variant="body2" fontStyle="italic" color="text.secondary">
                  Dovrai usare le stesse credenziali di accesso di HUB
                </Typography>
                <DefaultContainedButton
                  customStyles={{ marginTop: '16px' }}
                  onClick={() => window.open('https://mob.partitodemocratico.it', '_blank')}
                >
                  Vai
                </DefaultContainedButton>
              </CardContent>
            </Card>
          </Grid>

          {/* User Survey card UI */}
          {/* <Grid item xs={12} sm={12}>
            <AppSurvey profile={profile} />
          </Grid> */}
        </Grid>
      </Container>
    </div>
  );
}
